import {inject, injectable} from "inversify";
import {EventEmitter} from "@/modules/base/events";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";
import {Player} from "@/modules/team/entity";

@injectable()
export default class PlayerContractReleaser {
  constructor(
    @inject(EventEmitter) private em: EventEmitter,
    @inject(ConfigRepository) private configRepository: ConfigRepository,
  ) {
  }

  async release(player: Player) {
    player.contractYears = null;
    player.team = null;
    await player.save();
  }
}
